import {State, Getter, Action, Mutation, namespace} from 'vuex-class'
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {PaginationTable} from '@/components'

@Component({name: 'Stores', components: {PaginationTable}})
export default class Stores extends Vue {
  //@Prop() private prop?: string;
  @State('storeStatus', {namespace: 'common'}) storeStatus: any
  @Action('changeCommonData', {namespace: 'common'}) changeCommonData: any
  @Action('verifyStore', {namespace: 'mall'}) verifyStore: any
  // 初始化数据
  timestamp = new Date().getTime()

  // 计算属性 computed
  get users() {
    return []
  }

  create() {

  }

  // 声明周期钩子
  mounted() {
    this.changeCommonData({
      tableUrl: '/queryStore',
      listKey: 'storeList',
      tableParams: {
        mod: 'web',
        examine: ''
      },
      tableProps: [
        {
          prop: 'storeName',
          label: '名称'
        },
        {
          prop: 'storeImg',
          label: '店铺Logo',
          hasSlot: true
        },
        {
          prop: 'storePresen',
          label: '店铺介绍'
        },
        {
          prop: 'identType',
          label: '认证类型',
          hasSlot: true
        },
        {
          prop: 'examine',
          label: '审核状态',
          hasSlot: true
        },
        {
          prop: 'applyTime',
          label: '申请时间'
        },
        {
          prop: 'edit',
          label: '操作',
          hasSlot: true
        }
      ]
    })
  }

  @Watch('watchValue')
  watchValue(val: any) {

  }

  onVerify(data: any) {
    const {examine, storeId} = data
    const {verifyStore, changeCommonData} = this;
    (async () => {
      const {isOk} = await verifyStore({storeId, examine: examine !== '0' ? 0 : 1})
      if (isOk) {
        await changeCommonData({refreshTable: true})
      }
    })();
  }
}
